<template>
  <div>
    <span class="section-row-header">{{item.freeProductLabel}}</span>
    <div :class="['mini-cart-product', {'product-gift-ribbon': isGift}]">
        <div class="mini-cart-image" ref="miniCartImage">
            <a v-if="item.productLink" :href="item.productLink.url" :title="item.productLink.title">
                <img v-if="item.image" :class="item.image.class" :alt="item.image.alt"
                    :title="item.image.title" :src="item.image.placeholder" :data-src="item.image.src"/>
            </a>
            <img v-if="!item.productLink && item.image" :class="item.image.class" :alt="item.image.alt"
                    :title="item.image.title" :src="item.image.placeholder" :data-src="item.image.src"/>
        </div>

        <div class="mini-cart-info">
            <div v-if="item.ancientRitual" class="mini-cart-small-title">
                {{ item.ancientRitual }}

                <div class="mini-cart-price-wrapper" v-if="item.price.discountPrice && !item.price.standardProductValueResource">
                    <span class="value price-before-discount">{{ item.price.discountPrice }}</span>
                </div>
            </div>
            <div class="mini-cart-name mini-cart-product-name">
                <a v-if="item.productLink" :href="item.productLink.url" :title="item.productLink.title">
                    {{ item.title }}
                </a>

                <div v-if="!item.productLink">{{ item.title }}</div>

                <div class="mini-cart-price-wrapper">
                    <span class="value price-after-discount" v-if="item.price.discountPrice">{{ item.price.productPrice }}</span>
                    <span class="mini-cart-price" v-else>{{ item.price.productPrice }}</span>
                </div>
            </div>
            <div v-if="item.price.showBaseUnitPrice" class="mini-cart-unit-base">
                <div v-if="item.price.unitBasePrice" class="unit-base-price">
                    <div>
                        <span class="unit-volume">{{ item.price.unitBasePrice.originalVolume }}</span>
                        <span class="base-price">({{ item.price.unitBasePrice.basePriceText }})</span>
                    </div>
                    <div class="unit-base-price legal-note">
                        <span>{{ item.price.resources.vatIncluded }}</span>
                    </div>
                </div>
            </div>
            <div class="mini-cart-attributes">
                <div v-if="item.selectedAttributes" :class="item.selectedAttributes.cssClass">
                    <span class="label">{{ item.selectedAttributes.text }}</span>
                </div>
            </div>
            <div v-if="item.price.discountPrice && item.price.standardProductValueResource" class="mini-cart-details-bottom">
                <div class="mini-cart-pricing">
                    <span class="value">{{ item.price.standardProductValueResource + ' ' + item.price.discountPrice }}</span>
                </div>
            </div>
            <div class="mini-cart-details-bottom">
                <div v-if="item.promotionType" class="mini-cart-pricing">
                    {{ item.promotionType }}
                </div>
                <div v-else class="mini-cart-pricing">
                    <span class="value">{{ item.quantity }}</span>
                    <div v-if="item.errorMessage" class="error-form">
                        {{ item.errorMessage }}
                    </div>
                </div>
            </div>
        </div>
        <mini-cart-line-error :item="item"/>
    </div>
  </div>
</template>

<script src="./mini-cart-line-item.js"></script>
